import { Link } from 'react-router-dom';

export default function GuidePreview() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 text-xs font-semibold text-primary-700 bg-primary-100 rounded-full mb-4">
              Featured Guide
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 leading-tight">
              Pandabuy Shopping Guide 2026: The Complete Walkthrough
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              New to Pandabuy shopping? Our comprehensive shopping guide covers everything you need to know — 
              from understanding how spreadsheets work to finding the best deals, verifying sellers, and mastering
              the entire shopping process. Whether you are a beginner or an experienced shopper, this guide will help
              you make the most of every Pandabuy find.
            </p>
            <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
              Learn about <strong>advanced deal-finding strategies</strong>, how to read community reviews like a pro,
              and the best approaches for building your own long-term shopping system. Our guide is updated regularly
              with the latest tips and community recommendations.
            </p>
            <div className="mt-6">
              <Link
                to="/article/shopping-guide"
                className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-background-50 bg-foreground-900 hover:bg-foreground-800 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-open-line"></i>
                Read the Full Shopping Guide
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
          <div className="flex-shrink-0 w-full lg:w-80">
            <div className="bg-background-50 border border-background-200/70 rounded-2xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                  <i className="ri-article-line text-lg"></i>
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">Complete Shopping Guide</p>
                  <p className="text-xs text-foreground-500">Updated June 2026 · 10 min read</p>
                </div>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 leading-snug">
                Everything You Need to Master Pandabuy Shopping
              </h3>
              <p className="mt-2 text-xs text-foreground-600 leading-relaxed">
                Step-by-step walkthrough covering spreadsheets, deal-finding, community reviews, and long-term shopping strategies.
              </p>
              <ul className="mt-4 space-y-2">
                {[
                  'Understanding Pandabuy Spreadsheets',
                  'Choosing the right categories',
                  'Reading community reviews effectively',
                  'Advanced deal-finding strategies',
                ].map((item) => (
                  <li key={item} className="flex items-center gap-2 text-xs text-foreground-600">
                    <i className="ri-check-line text-accent-500 text-sm flex-shrink-0"></i>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}